export function arr2map(arr, keyId) {
    return arr.reduce((prev, curr) => {
        // eslint-disable-next-line no-param-reassign
        prev[curr[keyId]] = curr;
        return prev;
    }, {});
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXJyMm1hcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9hcnIybWFwLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sVUFBVSxPQUFPLENBQUksR0FBUSxFQUFFLEtBQWE7SUFDaEQsT0FBTyxHQUFHLENBQUMsTUFBTSxDQUFvQixDQUFDLElBQUksRUFBRSxJQUFJLEVBQUUsRUFBRTtRQUNsRCw2Q0FBNkM7UUFDN0MsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxHQUFHLElBQUksQ0FBQztRQUN6QixPQUFPLElBQUksQ0FBQztJQUNkLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQztBQUNULENBQUMifQ==